export default "__VITE_ASSET__ChU7VgBx__"